import { Box, FormControlLabel, styled, Typography } from "@mui/material";

export const RadioLabel = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": { fontSize: 12 },
  "& .MuiRadio-root": { padding: 4 },
});

export const Header = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0.5),
  fontSize: 12,
  fontWeight: 500,
  textAlign: "center",
  textTransform: "uppercase",
  backgroundColor: theme.palette.biarri.secondary.whiteSmoke,
  color: theme.palette.biarri.primary.red,
}));

export const Container = styled(Box, { shouldForwardProp: (prop) => prop !== "disabled" })<{ disabled?: boolean }>(({ disabled }) => ({
  marginBottom: 16,
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? "none" : "auto",
}));
